import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import MajorConfig from 'Configs/fields/majors.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.inquiries

const transformValues = function (selectedValues) {
  return selectedValues.map((value) =>
    value === MajorConfig.no_selection ? '' : value
  )
}

export const IntendedMajorsSlice = multiSelectSlice(
  MajorConfig.column,
  'setTimeBasedIntendedMajors',
  MajorConfig.data,
  MajorConfig.meta,
  transformValues
)

export const selectIntendedMajor = createSelector(
  ({ timeBasedFilter: { prospectProfile } }: RootState) =>
    prospectProfile.intendedMajors.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label: string
  } => {
    return {
      selectedValues,
      values: MajorConfig.data,
      audienceTypes: MajorConfig.source[contractSource].audience_types,
      label: MajorConfig.meta.label,
    }
  }
)

export const { setTimeBasedIntendedMajors } = IntendedMajorsSlice.actions

export default IntendedMajorsSlice.reducer
